import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

class Create extends Base {
  private body = z.object({
    name: z.string(),
    personType: z.enum(['FISICA', 'JURIDICA', 'OUTRA']),
    document: z.string(),
    nickname: z.string().optional(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post('/entity/persons/', body)
    return this.response.parse(data.result)
  }
}

class Edit extends Base {
  private body = z.object({
    name: z.string(),
    personType: z.enum(['FISICA', 'JURIDICA', 'OUTRA']),
    document: z.string(),
    nickname: z.string().optional(),
    active: z.boolean(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (id: string, body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.put('/entity/persons/' + id, body)
    return this.response.parse(data.result)
  }
}

class Search extends Base {
  private searchParams = z.object({
    search: z.string().optional(),
    active: z.boolean().optional(),
  })

  private response = z.array(DomainSchema.Person)

  handle = (searchParams: z.infer<typeof this.searchParams>) => {
    return useQuery(['person', 'search', { ...searchParams }], async () => {
      const queryParams = new MyURLSearchParams(searchParams).toString()
      const { data } = await this.axios.get('/entity/persons?' + queryParams)
      return this.response.parse(data.result)
    })
  }
}

class LoadOne extends Base {
  private response = DomainSchema.Person

  handle = (id: string) => {
    return useQuery(['person', 'load-one', { id }], async () => {
      const { data } = await this.axios.get('/entity/persons/' + id)
      return this.response.parse(data.result)
    })
  }
}

export default class extends Base {
  Create = new Create(this.axios).handle
  Edit = new Edit(this.axios).handle
  Search = new Search(this.axios).handle
  LoadOne = new LoadOne(this.axios).handle
}
